import { render, staticRenderFns } from "./BtnProcessar.vue?vue&type=template&id=341847af"
import script from "./BtnProcessar.vue?vue&type=script&lang=js"
export * from "./BtnProcessar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports